import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";

import icon from '../media/icon.png'

import { AuthMailUser, SetAuthUser } from "../services/user-accounts";
import { AuthLoginWebbUser } from "../services/user-accounts";

export default function AuthMailCodeModule() {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [btnPassword, setButtonPassword] = useState(true);
  const [btnLogin, setButtonLogin] = useState(false);
  const [text, setText] = useState("");
  
  const [loading,setLoading]=useState(false);
  const history = useHistory();

  const refreshPage = ()=> {
    window.location.reload(false);
  }

  const handleSubmit = async () => {
    //e.preventDefault();
    localStorage.clear();
    const user = { username, password };
    
    if (user.username==="" || user.password==="" ) {
      setText('Email and Password should not be empty');
    } else {
        
      const response = (await AuthMailUser(username, password)).data;
      console.log (response)
      if (response) {
        console.log (response)
        setText('Please wait...');
        SetAuthUser({...response, usid: response.enid});
        AuthLoginWebbUser();
        if (response.form === "us") history.push('/home');
        if (response.form === "bz") history.push('/bz/home');
        
      } 
      else {
        setText(response.text+'. Please try again.');
      }
    }
  };

  if (loading) 
  return (<> <p className="small text-muted">Please Wait...</p> </>)

  return (
    <>
    <div className="container">
      <div className="row">
        <div className="col d-none d-md-block"></div>
        <div className="col">
          <div className="text-center">
            <div className="py-3"></div>
            <img 
                src={icon} 
                width="60" height="60" alt="..."
                className=""
            ></img>
            <div className="py-3"></div>
          </div>

          <div className="mb-3">
            <label className="form-label small">Username <span className="text-danger">*</span></label>
            <input type="text" 
              
              className="form-control height-md" 
              disabled={btnLogin}
              value={username}
              onChange={({ target }) => {setUsername(target.value); setText('');}}
              placeholder="username@skillset">
            </input>
          </div>

          <div className="mb-3">
            <label className="form-label small">Passcode <span className="text-danger">*</span></label>
            <input type="password" 
              className="form-control height-md" 
              value={password}
              onChange={({ target }) => {setPassword(target.value); setText('');}}
              placeholder="enter passcode">
            </input>
          </div>

          
          <small className="text-danger">{text}</small>
          <div className="mb-3"></div>

          {/* action */}
          <div className={`mb-3 d-grid`}>
            <button type="button" 
              className="btn btn-primary height-md border-none"
              onClick={()=>handleSubmit()}
              ><small>Login</small>
            </button>
          </div>

        </div>
        <div className="col d-none d-md-block"></div>
      </div>
      
    </div>

    <div className="container">
      <div className="row">
        <div className="col d-none d-md-block"></div>
        <div className="col small">
          
          <div className="">
            <div className="mb-3 border-top"></div>
            <small className="">Don't Have an Account: </small>
            <Link to='/account/create' className="small link-primary">Register Here</Link>

          </div>


        </div>
        <div className="col d-none d-md-block"></div>
      </div>
      
    </div>

    </>
  )
}